import { styled, Tab, Tabs } from "@mui/material";
import { colors } from "styles/AtomicStyles";

export const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ style: { display: "none" } }}
  />
))({
  minHeight: 0,
});

export const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: "16px",
    marginRight: theme.spacing(1),
    color: colors.gray,
    minWidth: 0,
    padding: "0 16px",
    position: "relative",
    "&:after": {
      content: '""',
      display: "block",
      height: "2px",
      background: colors.gray2,
      width: "90%",
      position: "absolute",
      left: "5%",
      bottom: 0,
      borderRadius: "1px",
      transition: "background 0.3s",
    },
    "&.Mui-selected": {
      color: colors.primary,
      fontWeight: 700,
    },
    "&.Mui-selected:after": {
      background: colors.primary,
    },
  })
);
